export const COOKIE_CONSENT_DEFAULTS = {
	analytics: false,
	marketing: false,
	preferences: false,
};

export const COOKIE_CONSENT_ALL = {
	analytics: true,
	marketing: true,
	preferences: true,
};

export const COOKIE_CONSENT_TOGGLE_KEYS = [
	'analytics',
	'marketing',
	'preferences',
];

export const COOKIE_CONSENT_PRIVACY_HREF = '/PRIVACY POLICY.pdf';

export const COOKIE_CONSENT_QUERY_PARAM = 'cookieConsent';
